// eslint-disable-next-line @typescript-eslint/no-unused-vars
const exhaustivenessCheck = (_: never): Error => {
  throw new Error('Exhaustiveness check failed')
}

export default exhaustivenessCheck
